export const getRedirectPath = (): string => {
  const { href, origin } = window.location

  return href.replace(origin, '')
}
